import script from "./individual-proxy-fee-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./individual-proxy-fee-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__